module.exports = __webpack_public_path__ + "img/CON1.4c6ce3b4.png";